import React, { useState, useRef, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const items = [{
  emoji: '🎯',
  title: '6 Tomos de Planificación Integral (PDF)',
  desc: 'Tomo 1: Reformer Explosivo (24 clases de Inicial a Avanzado). Tomo 2: Mat Pilates & Props (32 clases con todos los accesorios).',
  color: 'bg-blue-500',
  shadow: 'shadow-[0_0_15px_rgba(59,130,246,0.5)]'
}, {
  emoji: '📋',
  title: 'Pilates Clínico y Poblaciones Especiales',
  desc: 'Tomo 3: Pilates Clínico (11 protocolos para las patologías más comunes). Tomo 4: Poblaciones Especiales (Clases para embarazo y adultos mayores).',
  color: 'bg-green-500',
  shadow: 'shadow-[0_0_15px_rgba(34,197,94,0.5)]'
}, {
  emoji: '📱',
  title: 'Flow, Transiciones y Negocio',
  desc: 'Tomo 5: Flow & Transiciones (Secuencias dinámicas que enamoran). Tomo 6: Planilla de Negocio (Gestión de cobros, agenda y métricas).',
  color: 'bg-purple-500',
  shadow: 'shadow-[0_0_15px_rgba(168,85,247,0.5)]'
}, {
  emoji: '🧤',
  title: 'Bono Especial: Manual de Posturología Experta',
  desc: 'Protocolos de élite para casos complejos: espondilolistesis, fibromialgia, SHA e informes para médicos. Criterio técnico para cobrar como especialista.',
  color: 'bg-orange-500',
  shadow: 'shadow-[0_0_15px_rgba(249,115,22,0.5)]'
}];
const carouselImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/6REUG82Zv8s2oAoYWQWa4q/Captura_de_pantalla_2026-04-21_a_la(s)_9.50.39_p._m..png',
  alt: 'Clases de Columna Vertebral 360° y Desafío de Equilibrio'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/83UXugSTaYPb5nBZnSm7YX/Captura_de_pantalla_2026-04-21_a_la(s)_9.51.00_p._m..png',
  alt: 'Bloque 2 — Mat con Pelota de Pilates'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qbZQXApTLqzh6dtjnVuKio/Captura_de_pantalla_2026-04-21_a_la(s)_9.51.30_p._m..png',
  alt: 'Protocolo 6 — Hipercifosis Dorsal'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gY8KnQV3RHYxmS85GJQoiS/Captura_de_pantalla_2026-04-21_a_la(s)_9.51.51_p._m..png',
  alt: 'Resumen de Clases por Trimestre'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/v6kjBisUPgP1AWRBhtDGNn/Captura_de_pantalla_2026-04-21_a_la(s)_9.52.18_p._m..png',
  alt: 'Mat Express 30 Online — Clase Virtual'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/t6qsPcqgp3RASMAVk9fU3g/Captura_de_pantalla_2026-04-21_a_la(s)_9.53.35_p._m..png',
  alt: 'Planilla Maestra de Cobros — Tabla de Tarifas'
}];
export function ContentPreview() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const center = container.scrollLeft + container.clientWidth / 2;
    let minDistance = Infinity;
    let active = 0;
    Array.from(container.children).forEach((child, index) => {
      const childCenter = (child as HTMLElement).offsetLeft + (child as HTMLElement).clientWidth / 2;
      const distance = Math.abs(center - childCenter);
      if (distance < minDistance) {
        minDistance = distance;
        active = index;
      }
    });
    setActiveIndex(active);
  };
  const scrollToIndex = (index: number) => {
    if (!scrollRef.current) return;
    const container = scrollRef.current;
    const child = container.children[index] as HTMLElement;
    if (!child) return;
    const scrollLeft = child.offsetLeft - container.clientWidth / 2 + child.clientWidth / 2;
    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  };
  const scrollPrev = () => {
    if (activeIndex > 0) scrollToIndex(activeIndex - 1);
  };
  const scrollNext = () => {
    if (activeIndex < carouselImages.length - 1) scrollToIndex(activeIndex + 1);
  };
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-23">
      <div className="max-w-5xl mx-auto" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-26">
            ¿Qué incluye el MegaPack Pilates de EDULABS™?
          </h2>
          <p className="text-text-sec text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-27">
            Herramientas digitales en PDF listas para usar desde hoy mismo.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-28">
          {items.map((item, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light overflow-hidden flex flex-col relative group hover:-translate-y-1 transition-transform duration-300" data-id="element-29">
              <div className={`${item.color} h-1.5 w-full ${item.shadow}`} data-id="element-30" />
              <div className="flex-1 flex flex-col p-8 relative" data-id="element-31">
                {/* Subtle background glow */}
                <div className={`absolute inset-0 ${item.color} opacity-[0.03] group-hover:opacity-[0.08] transition-opacity`} data-id="element-32"></div>

                <span className="text-5xl mb-5 block drop-shadow-2xl relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-33">
                  {item.emoji}
                </span>
                <h3 className="text-xl sm:text-2xl font-bold text-text-main leading-snug relative z-10 mb-3" data-id="element-34">
                  {item.title}
                </h3>
                <p className="text-text-sec text-base leading-relaxed relative z-10" data-id="element-35">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Carousel Section */}
        <div className="mt-24 relative" data-id="element-36">
          <div className="text-center mb-10" data-id="element-37">
            <h3 className="text-2xl sm:text-3xl font-bold text-text-main inline-flex items-center gap-3" data-id="element-38">
              <span data-id="element-39">📸</span> Mira el material por dentro
            </h3>
            <p className="text-text-sec text-sm mt-3 flex items-center justify-center gap-2" data-id="element-40">
              <span className="inline-flex items-center gap-1.5 sm:hidden" data-id="element-41">
                <ChevronLeft className="w-4 h-4 animate-pulse" data-id="element-42" />
                Desliza para ver más
                <ChevronRight className="w-4 h-4 animate-pulse" data-id="element-43" />
              </span>
              <span className="text-text-sec text-xs font-medium" data-id="element-44">
                {activeIndex + 1} / {carouselImages.length}
              </span>
            </p>
          </div>

          <div className="relative group max-w-[100vw] -mx-4 sm:mx-0" data-id="element-45">
            {/* Navigation buttons */}
            <button onClick={scrollPrev} className={`hidden sm:flex absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-bg-dark/80 hover:bg-bg-alt border border-border-light p-3 rounded-full text-text-main backdrop-blur-sm transition-all shadow-lg ${activeIndex === 0 ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} aria-label="Anterior" data-id="element-46">
              <ChevronLeft className="w-6 h-6" data-id="element-47" />
            </button>
            <button onClick={scrollNext} className={`hidden sm:flex absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-bg-dark/80 hover:bg-bg-alt border border-border-light p-3 rounded-full text-text-main backdrop-blur-sm transition-all shadow-lg ${activeIndex === carouselImages.length - 1 ? 'opacity-0 pointer-events-none' : 'opacity-100'}`} aria-label="Siguiente" data-id="element-48">
              <ChevronRight className="w-6 h-6" data-id="element-49" />
            </button>

            {/* Carousel */}
            <div ref={scrollRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-4 sm:gap-6 px-[10vw] sm:px-[calc(50%-175px)] pb-8 pt-4" data-id="element-50">
              {carouselImages.map((img, i) => <div key={i} className={`snap-center shrink-0 w-[80vw] sm:w-[350px] bg-bg-alt border border-border-light rounded-2xl overflow-hidden p-2 sm:p-3 flex items-center justify-center shadow-[0_10px_30px_rgba(0,0,0,0.3)] transition-transform duration-300 ${activeIndex === i ? 'scale-100 opacity-100' : 'scale-95 opacity-50'}`} data-id="element-51">
                  <img src={img.src} alt={img.alt} loading="lazy" decoding="async" width={800} height={1131} className="w-full h-auto max-h-[400px] sm:max-h-[450px] object-contain rounded-xl bg-white/5" data-id="element-52" />
                </div>)}
            </div>
          </div>

          {/* Dots — min 48px tap target via padding */}
          <div className="flex justify-center gap-1 mt-2" data-id="element-53">
            {carouselImages.map((_, i) => <button key={i} onClick={() => scrollToIndex(i)} className="p-3 flex items-center justify-center" aria-label={`Ir a imagen ${i + 1}`} data-id="element-54">
                <span className={`block h-2 rounded-full transition-all duration-300 ${i === activeIndex ? 'bg-primary w-8' : 'bg-border-light hover:bg-text-sec w-2'}`} data-id="element-55" />
              </button>)}
          </div>
        </div>
      </div>
    </section>;
}